export default __webpack_public_path__ + "static/videoImageWeb-602fcd28fe3da30c625efb1d5d14b744.png";